module.exports = __webpack_public_path__ + "img/Incoming orange.dd6a1a33.png";